import { useToastContext } from "components/alert/ToastContext";
import BaseListagem from "components/BaseListagem";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import Usuario from "model/administracao/cadastro/Usuario";
import OperacaoProducao from "model/meta/producao/OperacaoProducao";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import saveAs from 'file-saver';
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ApontamentoOperacaoService from "service/meta/producao/ApontamentoOperacaoService";
import { converterData, converterDataHora } from "utils/convert";
import { DateMatchModeOptions, IdMatchModeOptions, NumberMatchModeOptions, ProdutoFilterTemplate, TextMatchModeOptions, dateRangeFilterTemplate, decimalFilterTemplate, dropdownFilterTemplate, filterApplyTemplate } from "utils/filterUtils";
import { SplitButton } from "primereact/splitbutton";
import { Dialog } from "primereact/dialog";
import ReportEdit from "components/reports/ReportEdit";
import { Button } from "primereact/button";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";

const apontamentoOperacaoService = new ApontamentoOperacaoService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function ApontamentoOperacaoListagem() {

    const [queryParameters] = useSearchParams();

    const { msgErro } = useToastContext();

    const { startLoading, stopLoading } = useLoadingContext();

    const [titulo, setTitulo] = useState<string>('Apontamentos de Operação');
    const [produtos, setProdutos] = useState<Produto[]>([]);
    const [clientes, setClientes] = useState<Pessoa[]>([]);
    const [operacoes, setOperacoes] = useState<OperacaoProducao[]>([]);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [editaRelatorio, setEditaRelatorio] = useState<boolean>(false);
    const [visibleEditarRelatorio, setVisibleEditarRelatorio] = useState<boolean>(false);

    useEffect(() => {
        apontamentoOperacaoService.produtos().then((response) => {
            setProdutos(response);
        }).catch((err) => {
            console.error(err);
        });
        apontamentoOperacaoService.clientes().then((response) => {
            setClientes(response);
        }).catch((err) => {
            console.error(err);
        });
        apontamentoOperacaoService.operacoes().then((response) => {
            setOperacoes(response);
        }).catch((err) => {
            console.error(err);
        });
        apontamentoOperacaoService.usuarios().then((response) => {
            setUsuarios(response);
        }).catch((err) => {
            console.error(err);
        });
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            setEditaRelatorio(usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_APONTAMENTO_OPERACAO_META", "RELATORIO_APONTAMENTO_OPERACAO_META_AGRUPADO"]));
        }).catch((erro) => {
            console.log(erro);
        });
    }, []);

    const defaultFilters: DataTableFilterMeta = {
        produto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        cliente: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        operacao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        usuario: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        data: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        quantidade: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const botoesExtra = () => {
        const model = [{ label: "Agrupado", icon: "pi pi-file-pdf", command: () => getRelatorioAgrupado() }];
        if (editaRelatorio) {
            model.push({ label: "Editar relatórios", icon: "pi pi-pencil", command: () => setVisibleEditarRelatorio(true) });
        }
        return [<SplitButton
            style={{ marginRight: '8px' }}
            key="btn2"
            label="Relatório"
            onClick={() => getRelatorio()}
            icon="pi pi-file-pdf"
            model={model}

        />]
    }

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);

    const getRelatorio = () => {
        startLoading();
        apontamentoOperacaoService.getRelatorio(filters).then((response) => {
            stopLoading();
            const file = new Blob([response], { type: 'application/pdf' });
            saveAs(file, "ApontamentoOperacaoMeta.pdf");
        }).catch((err) => {
            stopLoading();
            msgErro("Relatório", "Erro ao gerar relatório")
            console.log(err);
        })
    }

    const getRelatorioAgrupado = () => {
        startLoading();
        apontamentoOperacaoService.getRelatorioAgrupado(filters).then((response) => {
            stopLoading();
            const file = new Blob([response], { type: 'application/pdf' });
            saveAs(file, "ApontamentoOperacaoAgrupado.pdf");
        }).catch((err) => {
            stopLoading();
            msgErro("Relatório", "Erro ao gerar relatório")
            console.log(err);
        })
    }

    const dialogEditarRelatorio = (
        <Dialog header="Editar relatório" visible={visibleEditarRelatorio} onHide={() => setVisibleEditarRelatorio(false)} >
            <ReportEdit nomeAcao="RELATORIO_APONTAMENTO_OPERACAO_META" titulo="Relatório de Apontamento Operação" testarRelatorio={() => { }} style={{ marginBottom: 10 }} />
            <ReportEdit nomeAcao="RELATORIO_APONTAMENTO_OPERACAO_META_AGRUPADO" titulo="Relatório de Apontamento Operação Agrupado" testarRelatorio={() => { }} />
        </Dialog>
    )

    const footerGroup = (totalizadores: any) => {
        return <ColumnGroup>
            <Row>
                <Column footer="Total:" colSpan={5} footerStyle={{ textAlign: 'right' }} />
                <Column footer={totalizadores?.quantidade ? totalizadores?.quantidade : "0"} />
                <Column />
            </Row>
        </ColumnGroup>
    }

    return (
        <>
            {dialogEditarRelatorio}
            <BaseListagem ordenacao="dataApontamento,DESC" service={apontamentoOperacaoService} urlService="/apontamentoOperacao" tituloPagina={titulo}
                defaultFilters={defaultFilters}
                footerGroup={footerGroup}
                showClearFilterButton nome="apontamentoOperacao"
                showNewButton={false} showEditButton={false}
                buttonsExtra={botoesExtra()}
                onChangeFilters={(filters) => setFilters(filters)}>
                <Column field="metaProducaoOperacao.metaProducao.produto.nome" header="Produto" filterField="produto" filter showFilterOperator={false} showAddButton={false}
                    filterMatchModeOptions={IdMatchModeOptions} filterElement={(options) => <ProdutoFilterTemplate options={options} opcoes={produtos} />}
                    filterApply={filterApplyTemplate} />
                <Column field="metaProducaoOperacao.metaProducao.cliente.nome" header="Cliente" filter filterField="cliente" showFilterOperator={false} showAddButton={false}
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, clientes)} />
                <Column field="metaProducaoOperacao.operacao.descricao" header="Operação" filter filterField="operacao" showFilterOperator={false} showAddButton={false}
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, operacoes, "descricao")} />
                <Column field="usuario.nome" header="Usuário" filter filterField="usuario" showFilterOperator={false} showAddButton={false}
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, usuarios)} />
                <Column field="dataApontamento" header="Data"
                    body={(rowData) => converterDataHora(rowData.dataApontamento)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="data"
                    filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={dateRangeFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />
                <Column field="quantidade" header="Quantidade" filter filterField="quantidade" showFilterOperator={false} showAddButton={false} filterElement={decimalFilterTemplate}
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} />
            </BaseListagem>
        </>
    )
}